import { Label, Text } from "@fluentui/react-northstar";
import React from "react";
import { useTranslation } from "react-i18next";

const SentimentLabel = ({ sentiment }) => {
  const { t } = useTranslation();

  const feedbackSentimentTranslation = t("feedbackModule").body.sentiments;

  let color;

  switch (sentiment) {
    case "positive":
      color = "green";
      break;
    case "negative":
      color = "red";
      break;
    case "neutral":
      color = "yellow";
      break;
    default:
      color = "grey";
  }

  return sentiment ? (
    <Label
      circular
      style={{ padding: "13px 15px", textTransform: "capitalize" }}
      color={color}
      content={
        <Text
          weight="regular"
          content={feedbackSentimentTranslation[sentiment]}
        />
      }
    />
  ) : (
    " - "
  );
};

export default SentimentLabel;
